<div *ngIf="listing; else showCard">
  <div class="card">
    <div class="carousel-container" (click)="navigateToDetail(listing.id)">
      <ng-container *ngIf="Images.length > 0; else noImage">
        <app-image-slide [slides]="Images"></app-image-slide>
      </ng-container>
      <ng-template #noImage>
        <app-image-slide
          [slides]="['../../assets/images/defaultproperty.png']"></app-image-slide>
      </ng-template>
    </div>

    <div class="card-body">
   <div class="listing-header fupropcard" [ngClass]="{ 'no-padding-right': isHomePropertyPage() }">

        <!-- Edit Icon in Top-Right Corner -->
        <i class="fa fa-edit setonly setbutton" *ngIf="editButton"
          style="position: absolute; top: 0; right: 0; cursor: pointer; font-size: 20px; color: #004aad;"
          aria-hidden="true" (click)="editDetail(listing.id)"></i>

        <!-- Left Side: Title + Type -->
        <h5 (click)="navigateToDetail(listing.id)" style="margin: 0;">
          <span style="font-size: 24px; font-weight: 700;">
            {{ listing.title | capitalize }}
          </span>
          <span style="color: rgb(103, 89, 89);">
            ({{ listing.type }})
          </span>
        </h5>

        <span>
          <span style="color: #004aad; font-size: 24px;">
            {{ listing.propertyRentPrice ? ('₹' +
            listing.propertyRentPrice.toLocaleString('en-IN')) : '₹10,000' }}
            /
          </span><span style="font-size: 20px; ">Month</span>
        </span>
      </div>

      <div class="listing-subheader mt-1">
        <h3>

          <span class="font1">
            <i class="fas fa-map-marker-alt"
              style="color: #666666;"></i>&nbsp;{{
            listing.area }},{{ listing.cityName }}
          </span>
        </h3>
      </div>


<div class="row my-custom-listing">
  <div class="col-6 col-md-4 mb-2 d-flex align-items-center">
    <i class="fas fa-couch icon-hide-mobile me-2 icon-gap" style="color: #666;"></i>
    <span class="font1">{{ listing.furnishing }}</span>
  </div>

  <div class="col-6 col-md-4 mb-2 d-flex align-items-center">
    <i class="fas fa-home icon-hide-mobile me-2 icon-gap" style="color: #666;"></i>
    <span class="font1">{{ listing.widthOfFacingRoadUnit }}</span>
  </div>

  <div class="col-6 col-md-4 mb-2 d-flex align-items-center">
    <i class="fas fa-city icon-hide-mobile me-2 icon-gap" style="color: #666;"></i>
    <span class="font1">{{ listing.propertyType }}</span>
  </div>
</div>






      <div class="listing-description">
        <span class="description-text"
          [innerHTML]="listing.description | safeHtml"></span>
      </div>

      <div class="row px-2">
        <!-- Amenities Section -->
        <div class="col-12 col-md-7 mb-3">
          <div class="rounded amenuties mt-3"
            style="background-color: #dee9fb;">
            <div class="row">

              <div *ngIf="hasAmenity('Security')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-lock me-2"></i>
                <span>Security</span>
              </div>

              <div *ngIf="hasAmenity('Garden')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-leaf me-2"></i>
                <span>Garden</span>
              </div>

              <div *ngIf="hasAmenity('Gym')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-bolt me-2"></i>
                <span>Gym</span>
              </div>

              <div *ngIf="hasAmenity('Guest Suite')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-bell me-2"></i>
                <span>Guest Suite</span>
              </div>

              <div *ngIf="hasAmenity('Banquet Hall')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-glass me-2"></i>
                <span>Banquet Hall</span>
              </div>

              <div *ngIf="hasAmenity('Meeting Room')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-users me-2"></i>
                <span>Meeting Room</span>
              </div>

              <div *ngIf="hasAmenity('Music Room')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-music me-2"></i>
                <span>Music Room</span>
              </div>

              <div *ngIf="hasAmenity('Swimming Pool')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-life-ring me-2"></i>
                <span>Swimming Pool</span>
              </div>

              <div *ngIf="hasAmenity('Pool')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-tint me-2"></i>
                <span>Pool</span>
              </div>

              <div *ngIf="hasAmenity('Game Room')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-gamepad me-2"></i>
                <span>Game Room</span>
              </div>

              <div *ngIf="hasAmenity('Study Room')"
                class="col-6 mb-3 d-flex align-items-center amenities-item">
                <i class="fa fa-book me-2"></i>
                <span>Study Room</span>
              </div>

            </div>
          </div>
        </div>

        <!-- Buttons Section -->
        <div class="col-12 col-md-5 mb-3">
          <div class="listing-footer">

            <!-- Uncomment if needed -->
            <div *ngIf="editButton" class="footer-btn mb-2 setedit setbutton">
              <button class="btn btn-primary w-100"
                (click)="editDetail(listing.id)">
                <i class="fa fa-edit" aria-hidden="true"></i>&nbsp; Edit Details
              </button>
            </div>

            <div class="footer-btn mb-2">
              <button class="btn btn-primary w-100 setbutton"
                (click)="navigateToDetail(listing.id)">
                <i class="fa fa-star" aria-hidden="true"></i>&nbsp; View Details
              </button>
            </div>

            <div class="footer-btn mb-2">
              <button class="btn btn-primary w-100 setbutton"
                (click)="openShareModal(listing)">
                <i class="fa fa-share-alt" aria-hidden="true"></i>&nbsp; Share
              </button>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ELSE: Show Card Data -->
<ng-template #showCard>
  <div *ngIf="card; else showCards" class="card">
    <div class="carousel-container" (click)="viewDetails($event)">
      <ng-container *ngIf="cardImages.length > 0; else noCardImage">
        <app-image-slide [slides]="cardImages"></app-image-slide>
      </ng-container>
      <ng-template #noCardImage>
        <app-image-slide
          [slides]="['../../assets/images/defaultproperty.png']"></app-image-slide>
      </ng-template>
    </div>

    <div class="card-body">
      <!-- <div class="listing-header">
        <h5 (click)="navigateToDetail(card.id)">
          {{ card.title | capitalize }}

        </h5>
      </div> -->
      <div class="listing-details">
        <div class="price" (click)="viewDetails($event)">
          <span class="unit-value"> {{ card.title | capitalize }}</span>
        </div>

        <button class="inventory-btn" (click)="handleInventoryClick($event)">
          <span class="arrow"></span> Inventory ({{ card.totalInventory }})
        </button>

      </div>
      <div class="listing-subheader">
        <h3>
          <span class="font1" style="color: rgb(103, 89, 89);">
            {{ card.location }},{{ card.cityName }}
          </span>
        </h3>
      </div>

      <div class="listing-details">
        <div class="price">
          <span class="unit-value">₹{{ card?.fromPrice | formatNumber:
            card?.fromPriceUnit }}-{{ card?.toPrice | formatNumber:
            card?.toPriceUnit }}</span>
          <p class="unit-per-unit">FromPrice - ToPrice</p>
        </div>

        <div class="area">
          <span class="unit-value">{{ card?.size }} {{ card?.sizeUnit }}</span>
          <p class="unit-per-unit">Project Size</p>
        </div>

        <div class="bhk-status">
          <span class="unit-value">{{ card?.inventoryType |
            capitalizeFirstLetter }}</span>
          <p class="unit-per-unit">Project Type</p>
        </div>
      </div>

      <div class="listing-description">
        <span class="description-text"
          [innerHTML]="card.description | safeHtml"></span>
      </div>

      <div class="listing-footer">
        <div class="footer-info">
          <span>{{ card.createdAt | timeAgo }}</span><br>
          <span class="owner">Owner</span>
        </div>

        <div class="footer-info">
          <span>{{ card.type }}</span><br>
        </div>

        <div *ngIf="editButton" class="footer-btn">
          <button class="btn btn-primary" (click)="editDetails($event)">
            <i class="fa fa-edit" aria-hidden="true"></i>&nbsp; Edit Details
          </button>
        </div>

        <div class="footer-btn">
          <button class="btn btn-primary" (click)="viewDetails($event)">
            <i class="fa fa-star" aria-hidden="true"></i>&nbsp; View Details
          </button>
        </div>

        <div class="footer-btn">
          <button *ngIf="isMyProjectsPage(); else showInventory"
            class="btn btn-primary" (click)="myinventory($event)">
            <i class="fa fa-home-alt" aria-hidden="true"></i>&nbsp;My Inventory
          </button>

          <ng-template #showInventory>
            <button class="btn btn-primary" (click)="inventory($event)">
              <i class="fa fa-home-alt" aria-hidden="true"></i>&nbsp;Inventory
            </button>
          </ng-template>
        </div>

      </div>
    </div>
  </div>
  <ng-template #showCards>
    <div *ngIf="cardinventory;" class="card">
      <div class="carousel-container" (click)="inventorydetails($event)">
        <ng-container *ngIf="cardImagesinventory.length > 0; else noCardImage">
          <app-image-slide [slides]="cardImagesinventory"></app-image-slide>
        </ng-container>
        <ng-template #noCardImage>
          <app-image-slide
            [slides]="['../../assets/images/defaultproperty.png']"></app-image-slide>
        </ng-template>
      </div>

      <div class="card-body">
        <!-- <div class="listing-details">
          <div class="price" (click)="viewDetails($event)">
            <span class="unit-value"> {{ cardData.title | capitalize }}</span>
          </div>
        </div> -->

        <div class="listing-details">
          <div class="price" (click)="inventorydetails($event)">
            <span class="unit-value"> {{ cardinventory.title | capitalize
              }}</span>
          </div>

        </div>
        <div class="listing-subheader">
          <h3>
            <span class="font1" style="color: rgb(103, 89, 89);">
              {{ cardinventory?.projectFeature?.location }}
            </span>
          </h3>
        </div>

        <div class="listing-details">
          <div class="price">
            <span class="unit-value">₹{{ cardinventory?.aaskingPrice |
              formatNumber: cardinventory?.aaskingPriceUnit }}</span>
            <p class="unit-per-unit">Inventorty Price</p>
          </div>

          <div class="area">
            <span class="unit-value">{{ cardinventory?.totalSize }} {{
              cardinventory?.sizeUnit }}</span>
            <p class="unit-per-unit">Inventory Size</p>
          </div>

          <div class="bhk-status">
            <span class="unit-value">{{ cardinventory?.inventoryType |
              capitalizeFirstLetter }}</span>
            <p class="unit-per-unit">Inventorty Type</p>
          </div>
        </div>

        <div class="listing-description">
          <span class="description-text"
            [innerHTML]="cardinventory?.description | safeHtml"></span>
        </div>

        <div class="listing-footer">
          <div class="footer-info">
            <span>{{ cardinventory?.createdAt | timeAgo }}</span><br>
            <span class="owner">Owner</span>
          </div>

          <div class="footer-info">
            <span>{{ cardinventory?.type }}</span><br>
          </div>
          <div class="footer-btn" *ngIf="showButton">
            <button class="btn btn-primary"
              (click)="editInventorydetaisl($event)">
              <i class="fa fa-edit" aria-hidden="true"></i>&nbsp; Edit Inventory
            </button>
          </div>

          <div class="footer-btn">
            <button class="btn btn-primary" (click)="inventorydetails($event)">
              <i class="fa fa-star" aria-hidden="true"></i>&nbsp; View Details
            </button>
          </div>
        </div>
      </div></div>
  </ng-template>

</ng-template>
